import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Dashboard_Alumnos from "../pages/Dashboard_Alumnos/index"

//Control Escolar
import AltaAlumno from "../pages/Control_Escolar/AltaAlumno"
import AltaEstudiante from "../pages/Control_Escolar/AltaEstudiante"

// Apps
import Control_Escolar from "../pages/Control_Escolar/index"
import DemoGrid from "../pages/DemoGrid/index"

// Caja
import Caja from "../pages/Caja/index"
import Recibo from "../pages/Caja/recibo"
import Contribuyentes from "../pages/Contribuyentes/index"

// Credenciales
import Credenciales from "../pages/Credenciales/index"

// Cobranza
import Cobranza from "../pages/Cobranza/index"

// UI
import PagesComingsoon from "../pages/Utility/pages-comingsoon"

//Testing
import Testing from "../pages/Testing"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/dashboard-alumnos", component: <Dashboard_Alumnos /> },
  { path: "/control_escolar", component: <Control_Escolar /> },
  { path: "/control_escolar/alta_alumno", component: <AltaAlumno /> },
  { path: "/control_escolar/alta_estudiante", component: <AltaEstudiante /> },
  { path: "/caja", component: <Caja /> },
  { path: "/caja/:idAlumno", component: <Caja /> },
  { path: "/caja/recibo", component: <Recibo /> },
  { path: "/caja/recibo/:idRecibo", component: <Recibo /> },
  { path: "/contribuyentes", component: <Contribuyentes /> },
  { path: "/demo_grid", component: <DemoGrid /> },
  { path: "/credenciales", component: <Credenciales /> },
  { path: "/cobranza", component: <Cobranza /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/commingsoon", component: <PagesComingsoon /> },
  { path: "/testing", component: <Testing /> },
]

export { authProtectedRoutes, publicRoutes }
